import * as React from 'react';
import type { SVGProps } from 'react';
const SvgDataUnification = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path d="M2.408 3.405a1 1 0 0 1 1-1H7.85a1 1 0 0 1 1 1v4.441a1 1 0 0 1-1 1H3.408a1 1 0 0 1-1-1zm2.964 7.221a.3.3 0 0 1 .514 0l1.045 1.736a.3.3 0 0 0 .19.138l1.974.457a.3.3 0 0 1 .159.49l-1.329 1.53a.3.3 0 0 0-.072.222l.175 2.02a.3.3 0 0 1-.416.302l-1.866-.79a.3.3 0 0 0-.234 0l-1.866.79a.3.3 0 0 1-.416-.303l.175-2.019a.3.3 0 0 0-.072-.222l-1.329-1.53a.3.3 0 0 1 .159-.49l1.975-.457a.3.3 0 0 0 .189-.138zm8.253.109a.3.3 0 0 1 .536 0l3.193 6.38a.3.3 0 0 1-.268.435H10.7a.3.3 0 0 1-.268-.434zm3.846-5.1a3.21 3.21 0 1 1-6.421 0 3.21 3.21 0 0 1 6.421 0" />
  </svg>
);
export default SvgDataUnification;
